/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CredentialIssuanceStartRequest
 */
export interface CredentialIssuanceStartRequest {
    /**
     * If this flag is not set, service would return an error in case if we have completed workflows with the same type
     * @type {boolean}
     * @memberof CredentialIssuanceStartRequest
     */
    createIfCompleted?: boolean;
}

/**
 * Check if a given object implements the CredentialIssuanceStartRequest interface.
 */
export function instanceOfCredentialIssuanceStartRequest(value: object): boolean {
    return true;
}

export function CredentialIssuanceStartRequestFromJSON(json: any): CredentialIssuanceStartRequest {
    return CredentialIssuanceStartRequestFromJSONTyped(json, false);
}

export function CredentialIssuanceStartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialIssuanceStartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'createIfCompleted': json['createIfCompleted'] == null ? undefined : json['createIfCompleted'],
    };
}

export function CredentialIssuanceStartRequestToJSON(value?: CredentialIssuanceStartRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createIfCompleted': value['createIfCompleted'],
    };
}

